import { PublicClientApplication } from '@azure/msal-browser';
import { useMemo } from 'react';
import './i18n';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './app-routes';
import { PageShell } from './components';
import { AppErrorBoundary } from './components/error/app-error-boundary';
import i18n from './i18n';
import { msalConfig } from './msal-config';
import AuthProvider from './providers/auth';
import { ToastProvider } from './providers/toast';

export const App = () => {
  const msalInstance = useMemo(() => new PublicClientApplication(msalConfig), []);
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <ToastProvider>
          <AuthProvider msalInstance={msalInstance}>
            <AppErrorBoundary>
              <PageShell>
                <AppRoutes />
              </PageShell>
            </AppErrorBoundary>
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
};
